import React from 'react';

import {SvgProps} from '../../helpers/type';

const Increase = ({className, onClick, rectangular}: SvgProps): JSX.Element => {
    return !rectangular ? (
        <svg
            className={className}
            onClick={onClick}
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="10" cy="10.5" r="9.5" stroke="#174943" />
            <path
                d="M10.9839 11.2799V13.9969H9.29388V11.2799H6.52488V9.6419H9.28088V6.9249H10.9709V9.6419H13.7399V11.2799H10.9839Z"
                fill="#174943"
            />
        </svg>
    ) : (
        <svg
            className={className}
            onClick={onClick}
            width="20"
            height="20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path stroke="#174943" d="M1.5 1.305h18v18h-18z" />
            <path
                d="M11.187 11.685v2.717h-1.69v-2.717H6.728v-1.638h2.756V7.33h1.69v2.717h2.769v1.638h-2.756Z"
                fill="#174943"
            />
        </svg>
    );
};

export default Increase;
